// extracted by mini-css-extract-plugin
export var row = "_vg-0";